import { FormikProps } from 'formik';
import { ViewResolver } from '@Components/ViewResolver';

import { initFormikValuesType } from '../../types';
import ApproveModalDesktop from './desktop/ApproveModalDesktop';
import ApproveModalMobile from './mobile/ApproveModalMobile';

interface ApproveModalProps {
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  handleApprove: () => void;
  handleReject: () => void;
  handleCancel: () => void;
  hideApproverSelection: boolean;
}

const ApproveModal: React.FC<ApproveModalProps> = (props) => {
  return (
    <ViewResolver
      desktop={<ApproveModalDesktop {...props} />}
      mobile={<ApproveModalMobile {...props} />}
    />
  );
};

export default ApproveModal;
